import { useEffect } from "react";

/**
 * Sets `document.title` while the component is mounted.
 * Restores the previous title on unmount so we don't leave stale tab names
 * after navigation. Used by routed pages to give the Chrome tab a useful
 * label per surface (Pitch, Login, Family Hub, etc.).
 */
export function useDocumentTitle(title) {
  useEffect(() => {
    if (!title) return;
    const prev = document.title;
    document.title = title;
    return () => { document.title = prev; };
  }, [title]);
}
